<div class="flex flex-col gap-x-2">
  <p class="font-light">{{ description() }}</p>
  <div
    #counter
    class="h-12 border border-neutral-50 flex items-center justify-between px-4 py-3"
  >
    <ng-icon
      name="heroMinus"
      size="24px"
      (click)="reduceNumber()"
      class="cursor-pointer"
    ></ng-icon>
    <ng-content></ng-content>
    <ng-icon
      name="heroPlus"
      size="24px"
      (click)="addNumber()"
      class="cursor-pointer"
    ></ng-icon>
  </div>
</div>
